import React from 'react';
import {
    CheckCircle,
    Cancel,
    HourglassEmpty,
    ErrorOutline,
} from '@mui/icons-material';
import { Stack, Alert, AlertTitle } from '@mui/material';
import { PENDING_APP_STATUS } from 'enums/Enrollment/PendingApplicationStatus';
import PageHeader from './PageHeader';

const FeedbackView = ({ status }) => {
    let Content = () => <> </>;

    switch (status) {
        case PENDING_APP_STATUS.EXPIRED:
            Content = () => (
                <Alert
                    severity="warning"
                    sx={{ fontSize: '1.1rem' }}
                    icon={<HourglassEmpty fontSize="large" />}
                >
                    <AlertTitle fontSize="1.2rem" paddingBottom={1}>
                        This application link has expired.
                    </AlertTitle>
                    Please contact your agent to request a new application link.
                    <br />
                    <br />
                    Please contact your agent for any questions or concerns.
                </Alert>
            );
            break;
        case PENDING_APP_STATUS.APPROVED:
            Content = () => (
                <Alert
                    severity="success"
                    sx={{ fontSize: '1.1rem' }}
                    icon={<CheckCircle fontSize="large" />}
                >
                    <AlertTitle fontSize="1.2rem">Thank you!</AlertTitle>
                    Thank you for confirming your application. Your application
                    has been submitted.
                </Alert>
            );
            break;
        case PENDING_APP_STATUS.REJECTED:
            Content = () => (
                <Alert
                    sx={{ fontSize: '1.1rem' }}
                    severity="error"
                    icon={<Cancel fontSize="large" />}
                >
                    <AlertTitle fontSize="1.2rem">
                        You have declined this application.
                    </AlertTitle>
                    Thank you for your response. Your agent has been notified.
                </Alert>
            );
            break;
        case PENDING_APP_STATUS.UNIDENTIFIED:
        default:
            Content = () => (
                <Alert
                    sx={{ fontSize: '1.1rem' }}
                    severity="warning"
                    icon={<ErrorOutline fontSize="large" />}
                >
                    <AlertTitle fontSize="1.2rem">
                        We are unable to identify this application.
                    </AlertTitle>
                    Please contact your agent to request a new application link.
                </Alert>
            );
            break;
    }

    return (
        <div>
            <PageHeader />
            <Stack
                padding={3}
                direction="column"
                alignItems="center"
                justifyContent="center"
                alignContent="center"
                sx={{
                    gap: '0.6rem',
                    paddingTop: '7rem',
                }}
            >
                <Content />
            </Stack>
        </div>
    );
};

export default FeedbackView;
